export default "__VITE_ASSET__VmRfMIx5__"